import { z } from 'zod';

const actorSystemSourceSchema = z.enum([
    "bond_issuance",
    "extraction",
    "indemnity_completed",
    "legacy",
    "scheduled_job",
    "underwriting",
]);
z.enum(["docusign"]);
const actorTypeSchema = z.enum(["user", "system", "vendor"]);
var Actor;
(function (Actor) {
    Actor.adminUser = (user) => ({
        type: "admin_user",
        user,
    });
    Actor.agentUser = (user) => ({
        type: "agent_user",
        user,
    });
    const isAdminUserActor = (user) => user.type === "admin";
    Actor.fromUser = (user) => {
        return isAdminUserActor(user)
            ? Actor.adminUser(user)
            : Actor.agentUser(user);
    };
    const isAdminUser = (admin) => admin.type === "admin_user";
    Actor.isAgentUser = (actor) => actor.type === "agent_user";
    Actor.isAdminUserType = (actor) => actor.type === "admin_user";
    const isAdminOnBehalfOf = (actor) => Actor.isAdminUserType(actor) && "onBehalfOf" in actor;
    Actor.adminOnBehalfOf = (admin, onBehalfOf) => ({
        type: "admin_user",
        user: isAdminUser(admin) ? admin.user : admin,
        onBehalfOf,
    });
    Actor.system = (source) => ({ type: "system", source });
    Actor.vendor = (source) => ({ type: "vendor", source });
    Actor.extractOnBehalfOf = (actor) => (actor.type === "agent_user" ? actor : Actor.agentUser(actor.onBehalfOf));
    Actor.getAgencyId = (actor) => {
        if (Actor.isAgentUser(actor))
            return actor.user.agencyId;
        if (isAdminOnBehalfOf(actor))
            return Actor.extractOnBehalfOf(actor).user.agencyId;
        return undefined;
    };
    Actor.toColumns = (actor) => {
        switch (actor.type) {
            case "admin_user":
            case "agent_user":
                return { actorType: "user", actorUserId: actor.user.id, actorSource: null };
            case "system":
                return { actorType: "system", actorUserId: null, actorSource: actor.source };
            case "vendor":
                return { actorType: "vendor", actorUserId: null, actorSource: actor.source };
        }
    };
})(Actor || (Actor = {}));

export { Actor, actorSystemSourceSchema, actorTypeSchema };
